import { DRAGGING_KEEP_IN_PLACE_STYLE, DRAGGING_STYLE } from '../../DragDrop'

export const DocumentsTableCellName = {
  Access: 'user_access',
  CreatedAt: 'created',
  CreatedBy: 'owner',
  Size: 'size',
  Title: 'name',
  Type: 'mime_type',
  Updated: 'updated',
  UpdatedBy: 'updated_by',
  Views: 'views',
}

export const ACTIVE_DRAGGING_STYLE = {
  ...DRAGGING_STYLE,
  ...DRAGGING_KEEP_IN_PLACE_STYLE,
}
